$(document).ready(function () {
    $('.modal.modal-ope-estimation').each(function () {
        const modal = $(this);

        // Fonction pour obtenir la valeur d'un cookie par son nom
        function getCookie(name) {
            let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (match) return match[2];
            return null;
        }

        // Fonction pour définir un cookie
        function setCookie(name, value, days) {
            const d = new Date();
            d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));  // Durée en jours
            let expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        }

        // Vérifier si l'utilisateur a déjà vu la popup (via un cookie)
        const popupSeen = getCookie('popup_seen');

        // Si le cookie n'existe pas ou si l'utilisateur n'a pas vu la popup depuis plus de 1 jour
        if (!popupSeen) {
            modal.modal('show');
        }

        // Quand l'utilisateur ferme la popup, enregistrer dans un cookie pour ne plus l'afficher pendant 1 jour
        modal.on('hidden.bs.modal', function () {
            setCookie('popup_seen', 'true', 1);
        });

        // Fermer la popup lorsqu'on clique sur le bouton et enregistrer le cookie
        $('#bouton-popup').on('click', function () {
            setCookie('popup_seen', 'true', 1);
            modal.modal('hide'); // Ferme la popup
        });
    });
});
